<template>
    <div :id="div_id" class="form-group" :class="{'input-group': append}">
        <label v-if="label" :for="named" class="control-label">{{ trans(label) }}</label>
        <input ref="input" :placeholder="placeholder" class="form-control" :class="input_class" v-on:input="updateValue($event.target.value)" :id="named" :type="type" :name="named" :value="getValue" :required="isrequired" :aria-describedby="'append-' + named" >
        <span v-if="append" class="input-group-addon" :id="'append-' + named">{{ append }}</span>
        <span v-if="hasError">{{ hasError }}</span>
    </div>
</template>
<script>
    export default{
        props: {
            id: { default: '' },
            name: { default: '' },
            div_id: { default: '' },
            input_class: { default: '' },
            placeholder: { default: '' },
            type: { default: 'text' },
            label: { default: '' },
            append: { default: false },
            req: { default: '' },
            value: { default: '' }
        },
        data: function () {
            return {
                the_div_id: '',
                errors: {}
            }
        },
        created() {
            this.$eventHub.$on('emitErrors', this.updateErrors);
            this.the_div_id = this.div_id;
            if (this.div_id === '') {
                this.the_div_id = 'form-group-' + this.uniqueid();
            }
//            this.$eventHub.$on('reset-data', this.reset);
        },
        computed: {
            isrequired() {
                return this.req === true;
            },
            hasError: function () {
                if(typeof this.errors[this.named] !== 'undefined'){
                    return this.errors[this.named][0];
                }
                return false;
            },
            getValue: function () {
                return $("<div/>").html(this.value).text();
            },
            named: function () {
                // Compute name depending on how deep it should be
                if (this.name == '') {
                    if(this.id == '') {
                        return this.label;
                    }
                    return this.id;
                }
                if(this.id == '') {
                    return this.name;
                }
                return this.name + '[' +  this.id + ']';
            }
        },
        methods: {
            updateErrors(data) {
                if(typeof data.errorName !== 'undefined') {
                    // DO SOMETHING
                }
                this.errors = data.errors;
            },
            updateValue: function (value) {
                // When the internal value changes, we $emit an event. Because this event is
                // named 'input', v-model will automatically update the parent value
                this.$emit('input', value);
            },
                // Reset Form Data
            reset () {
                this.value = '';
            }
        }
    }
</script>